import React from 'react';

import { Icon } from '@chakra-ui/react';

export const RpmIcon = props => (
  <Icon viewBox="0 0 24 24" w="full" h="full" color="inherit" {...props}>
    <path d="M8.716 4.455c.52 0 1.115.112 1.768.334l.162.054.166-.043c.099-.025.235-.072.404-.129.542-.186 1.448-.498 2.472-.498 2.97 0 4.967 2.646 5.951 7.844-1.818 1.547-5.31 1.994-8.762 1.045-2.348-.646-4.397-1.836-5.729-3.3l.11-.537c.489-2.515 1.122-4.77 3.458-4.77zm14.571 13.059c-1.258 1.912-4.27 2.313-6.573 2.313-3.179 0-6.382-.736-8.319-1.425-4.373-1.557-8.681-5.045-8.38-6.788.144-.829 1.628-1.309 4.07-1.332 1.469 1.736 3.81 3.146 6.489 3.882 1.341.369 2.68.547 3.947.547 2.506 0 4.715-.707 6.09-2.013 1.074.176 2.611.78 3.179 1.928.398.804.23 1.774-.503 2.888z" />
  </Icon>
);
